// src/components/OssEntryLink.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const OssEntryLink = () => {
  const { pathname } = useLocation();
  if (pathname !== '/') return null;

  return (
    <Box
      sx={{
        borderBottom: '1px solid #ccc8c2',
        bgcolor: '#e4e0da',
        px: 2,
        py: 0.75,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Typography
        variant="caption"
        sx={{ color: '#78716c', fontFamily: '"Courier New", Courier, monospace' }}
      >
        new →
      </Typography>
      <Typography
        component={Link}
        to="/oss"
        variant="caption"
        sx={{
          color: '#ea580c',
          fontFamily: '"Courier New", Courier, monospace',
          textDecoration: 'none',
          fontWeight: 600,
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        OSS Model Explorer
      </Typography>
      <Typography
        variant="caption"
        sx={{ color: '#78716c', fontFamily: '"Courier New", Courier, monospace' }}
      >
        — HuggingFace trending models, cards & stats
      </Typography>
    </Box>
  );
};

export default OssEntryLink;
